import { Component, OnInit, ViewChild, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import * as global from '../../global'
import { AuthService } from 'src/app/services/auth.service';
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { FacilityService } from 'src/app/services/facility.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as moment from 'moment';
import { RehabDocsPopupComponent } from 'src/app/shared/popup-dialogs/rehab-docs-popup/rehab-docs-popup/rehab-docs-popup.component';
import { PCCService } from 'src/app/services/pcc.service';
import { HttpResponse } from '@angular/common/http';
import { CensusListService } from '../../census-list/census-list..service';
import { CensusPatientListService } from '../../census-patient-list/census-patient-list.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { NoteEditorService } from '../../note-editor/note-editor.service';
import { NursingService } from '../nursing.service';
import { ExportNotesDialogComponent } from 'src/app/shared/popup-dialogs/export-notes-dialog/export-notes-dialog.component';
import { WatchHelpVideoDialog } from '../../drive/watch-help-video-dialog.component';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-nursing-census-list',
  templateUrl: './nursing-census-list.component.html',
  styleUrls: ['./nursing-census-list.component.css']
})
export class NursingCensusListComponent implements OnInit, AfterViewInit {
  global = global;
  currentUser;
  currentUserDetails;
  admin: Boolean = false;
  company: Boolean = false;
  rouding_sheet_Ids: any = [];
  chargesCountData: any = [];
  notesCountData: any = [];
  pagination: any = {};
  patients = [];
  patientRoundingSheets: any = [];
  total: number = 0;
  censusListFetchedOnce: boolean = true;
  facility_charge_capture_enabled = false;
  user_charge_capture_enabled = false;
  displayedColumns: string[] = [
    'status',
    'dateOfService',
    'name',
    'facility',
    'patients_count_total',
    'saved_signed_notes',
    'draft_submitted_charges',
    'operations'
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatSort) sort: MatSort;
  facilities = [];
  providers = [];
  selectedFacility;
  filter_facility_id = "";
  filter_provider_id = "";
  selected = '';
  private showPatientList: Boolean = false;
  loaderId = 'patient-rounding-sheets-loader';
  inprogress = false;
  showLimit = 7;
  providerIdParam: string;
  pccDefaultFac;
  public pccUserInfo;
  p2pSubscription: any;
  addressSubscription: any;
  FacilitiesSubscription: any;
  clickedRows = new Set<any>();
  isAuthorized = true;
  searchText: any;
  searchTextProvider: any;
  @Input() detect_refresh_child: string
  censusDate: string;
  censusStatus: string = "true";
  chargesResponse: any;
  draftCount: any;
  missingFaceSheetsCount: any;
  @Output() refreshCounts = new EventEmitter<any>();
  totalCensus: any;
  nurseAssocFacilities: any;
  nurseAssocProviders: any;
  selectedfacility: any;
  selectedProvider: any;

  constructor(
    private _authService: AuthService,
    private _censusListService: CensusListService,
    private censusPatientListServie: CensusPatientListService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private facilityService: FacilityService,
    private loader: NgxUiLoaderService,
    private dashboardService: DashboardService,
    private router: Router,
    private route: ActivatedRoute,
    private pccService: PCCService,
    private noteEditorService: NoteEditorService,
    private _service: NursingService,
  ) {
    this.currentUser = this._authService.currentUser;
    this.currentUserDetails = {
      id: this.currentUser._id,
      auth_key: this.currentUser.auth_key,
      usertype: this.currentUser.user_type
    }
    this.user_charge_capture_enabled = this.currentUser.charge_status;
    this.pagination = {
      page: 1,
      skip: 0,
      noOfensus: 0,
      hasNext: false,
      hasBack: false,
      limit: this.showLimit
    }
  }
  async ngOnInit() {
    this.pccService.pccUserinfo$.subscribe(value => {
      this.pccUserInfo = value;
    });
    await this.initNurseFacilities();
  }

  async initNurseFacilities() {
    await this._service.getAssociatedFacilities().subscribe((res: any) => {
      if (res.status == 200) {
        this.nurseAssocFacilities = res.data.array;
        this.facilities = this.nurseAssocFacilities;
        this.selectedfacility = this.nurseAssocFacilities[0];
        this.filter_facility_id = this.selectedfacility._id;
        this.getProvidersByFacility(this.filter_facility_id);
      }
    });
  }
  getProvidersByFacility(filter_facility_id) {
    this.nurseAssocFacilities.find(facility => { if (facility._id === filter_facility_id) this.nurseAssocProviders = facility.provider_ids_ref });
    this.nurseAssocProviders.sort((a, b) => a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase()));
    this.nurseAssocProviders = this.nurseAssocProviders.map(d => ({ ...d, name: `${d.first_name} ${d.last_name}, ${d.title}` }));
    this.providers = this.nurseAssocProviders;
    this.selectedProvider = this.nurseAssocProviders[0];
    this.filter_provider_id = this.selectedProvider._id;
    if (this.filter_provider_id && this.filter_facility_id) {
      setTimeout(() => {
        this.initPatientRoundingSheets(this.filter_facility_id, this.filter_provider_id, this.showLimit);
      }, 1000);
    }
  }
  viewRehabDocs(census_id) {
    this.dialog.open(RehabDocsPopupComponent, { data: census_id, width: '80%', height: '100vh' })
  }
  changeLimit(value) {
    this.showLimit = Number(value);
    this.handleFilterFacilityChange();
  }
  resetPagination() {
    this.pagination = {
      page: 1,
      skip: 0,
      noOfensus: 0,
      hasNext: false,
      hasBack: false,
      limit: this.showLimit
    }
  }
  applyRowColors(row) {
    if (row.date_obj) {
      const censusDate = new Date(`${row.date_obj.year}-${row.date_obj.month}-${row.date_obj.day}`).getTime();
      const currentDate = new Date();
      let day = currentDate.getDate();
      let month = currentDate.getMonth();
      let year = currentDate.getFullYear();
      const currentDateFormat = new Date(`${year}-${month + 1}-${day}`).getTime();
      if (censusDate < currentDateFormat) {
        return 'row-color-past';
      }
      else if (censusDate == currentDateFormat) {
        return 'row-color-present'
      } else if (censusDate > currentDateFormat) {
        return 'row-color-future'
      }
    }
    if (row.date && !row.date_obj) {
      let currentDate = new Date().toISOString();
      if (row.date < currentDate) {
        return 'row-color-past';
      }
    }
  }
  handlePagination() {
    this.pagination.noOfensus = (this.pagination.skip) + this.patientRoundingSheets?.length;
    if (this.pagination.noOfensus < this.totalCensus) {
      this.pagination.hasNext = true;
    } else {
      this.pagination.hasNext = false;
    }
    if (this.pagination.noOfensus > this.showLimit) {
      this.pagination.hasBack = true;
    } else {
      this.pagination.hasBack = false;
    }
  }
  handleBackClick() {
    this.pagination.page--;
    this.pagination.skip = (this.pagination.page - 1) * this.pagination.limit;
    this.pagination.limit = this.showLimit;
    this.initPatientRoundingSheets(this.filter_facility_id, this.filter_provider_id, this.showLimit);
  }
  handleNextClick() {
    this.pagination.page++;
    this.pagination.skip = (this.pagination.page - 1) * this.pagination.limit;
    this.pagination.limit = this.showLimit;
    this.initPatientRoundingSheets(this.filter_facility_id, this.filter_provider_id, this.showLimit);
  }
  initPatientRoundingSheets(facility_id?, provider_id?, limit?) {
    this.loader.startLoader(this.loaderId);
    this.searchText = '';
    this.searchTextProvider = '';
    this._censusListService.getCensusListWithNotesAndChargesCount(facility_id, provider_id, limit, false, this.censusStatus, this.pagination.skip).subscribe(async (response: any) => {
      if (response.status === 200) {
        this.patientRoundingSheets = response.data;
        this.totalCensus = response.total;
        this.handlePagination();
        this.sortData({ active: 'dateOfService', direction: 'desc' });
        this.dataSource = new MatTableDataSource(this.patientRoundingSheets);
      }
      this.loader.stopLoader(this.loaderId);
    })
  }
  initializeActiveCensus(facility_id) {
    this.loader.startLoader(this.loaderId);
    this.censusPatientListServie.initializeActiveCensus(facility_id).subscribe((response: any) => {
      if (response.status === 200) {
        this.loader.stopLoader(this.loaderId);
        this.toastr.success('Census has been initialized successfully')
      }
    })
  }
  isPCCFacility(facility_id) {
    for (const facility of this.facilities) {
      if (facility_id === facility._id) {
        if (facility.pcc_facId) {
          return true;
        }
      }
    }
  }
  isMatrixFacility(facility_id) {
    for (const facility of this.facilities) {
      if (facility_id === facility._id) {
        if (facility.source == 'MatrixCare') {
          return true;
        }
      }
    }
  }
  isLoggedInFacility(f) {
    return this.pccService.isLoggedInFacility(f);
  }
  sortData(sort: Sort) {
    const data = this.patientRoundingSheets.slice();
    data.forEach(element => {
      let day = element.date_obj.day.toString();
      if (day.length == 1) {
        day = '0' + day;
      }
      let month = element.date_obj.month.toString();

      if (month.length == 1) {
        month = '0' + month;
      }
      let year = element.date_obj.year.toString();
      let newDate = `${year}-${month}-${day}`;
      element.newDate = newDate;
    });
    this.patientRoundingSheets = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'dateOfService':
          return compare(new Date(a.newDate).getTime(), new Date(b.newDate).getTime(), isAsc);
        default: return 0;
      }
    });
    this.dataSource = new MatTableDataSource(this.patientRoundingSheets);
  }
  handleFilterFacilityChange() {
    this.getProvidersByFacility(this.filter_facility_id);
    this.displayedColumns = [
      'status',
      'dateOfService',
      'name',
      'facility',
      'patients_count_total',
      'saved_signed_notes',
      'draft_submitted_charges',
      'operations'
    ];
    this.resetPagination();
    if (this.currentUser?.additional_user_role === global.USER_TYPE.CNP) {
      this.displayedColumns = this.displayedColumns.filter(f => f != 'draft_submitted_charges');
    }
    this.censusListFetchedOnce = true;
    this.initPatientRoundingSheets(this.filter_facility_id && this.filter_facility_id, this.filter_provider_id, this.showLimit);
    this.selectedFacility = this.facilities.find(f => f._id === this.filter_facility_id);
    this.facility_charge_capture_enabled = this.selectedFacility?.enabled_charge_capture;
    if (!this.facility_charge_capture_enabled || !this.user_charge_capture_enabled) {
      this.displayedColumns.splice(this.displayedColumns.indexOf('draft_submitted_charges'), 1);
      this.displayedColumns.splice(this.displayedColumns.indexOf('status'), 1);
    }
  }
  is2LeggedAuthRequired(facilityId) {
    const facility = this.facilities.find(f => f._id === facilityId);
    if (facility && facility.pcc_facId && !facility.pcc_2_legged_authentication) {
      if (!this.isLoggedIntoPCC()) return true;
      if (!this.pccService.isLoggedInFacility(facility)) return true;
    }
    return false;
  }
  handleproviderChange(provider) {
    this.refreshCounts.emit(this.filter_provider_id);
    this.censusListFetchedOnce = true;
    this.displayedColumns = [
      'status',
      'dateOfService',
      'name',
      'facility',
      'patients_count_total',
      'saved_signed_notes',
      'draft_submitted_charges',
      'operations'
    ];
    this.resetPagination();
    if (this.currentUser?.additional_user_role === global.USER_TYPE.CNP) {
      this.displayedColumns = this.displayedColumns.filter(f => f != 'draft_submitted_charges');
    }
    this.censusListFetchedOnce = true;
    this.initPatientRoundingSheets(this.filter_facility_id && this.filter_facility_id, this.filter_provider_id, this.showLimit);
    this.selectedFacility = this.facilities.find(f => f._id === this.filter_facility_id);
    this.facility_charge_capture_enabled = this.selectedFacility?.enabled_charge_capture;
    if (!this.facility_charge_capture_enabled || !this.user_charge_capture_enabled) {
      this.displayedColumns.splice(this.displayedColumns.indexOf('draft_submitted_charges'), 1);
      this.displayedColumns.splice(this.displayedColumns.indexOf('status'), 1);
    }
  }
  async viewClicked(census_id) {
    localStorage.setItem('hide_census', 'false')
    let pro;
    if (this.providerIdParam) {
      const userDetailResponse: any = await this.dashboardService.getUserDetail(this.providerIdParam).toPromise();
      if (userDetailResponse.status == 200) {
        pro = userDetailResponse.data;
      }
    } else {
      pro = this.providers.filter(p => p._id == this.filter_provider_id);
    }
    let telemedicine = pro[0]?.other_settings?.show_telemedicine || 'false';
    if (this.admin) {
      this.router.navigateByUrl(`/admin/census/${census_id};telemedicine=${telemedicine}`, { relativeTo: this.route });
      this.showPatientList = true;
    }
    if (this.company) {
      this.router.navigateByUrl(`/company/${this.currentUser.company_id}/census/${census_id};telemedicine=${telemedicine}`, { relativeTo: this.route });
      this.showPatientList = true;
    }
    else {
      this.showPatientList = false;
      this.router.navigateByUrl(`/census/${census_id};telemedicine=${telemedicine}`);
    }
  }
  ngAfterViewInit() {
    if (this.dataSource?.sort) {
      this.dataSource.sort = this.sort;
    }
  }
  isLoggedIntoPCC() {
    return !!this.pccUserInfo;
  }
  getDOS(patientRoundingSheet) {
    if (patientRoundingSheet.date_obj) {
      let { year, month, day } = patientRoundingSheet.date_obj;
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return `${month}/${day}/${year}`;
    }
    if (!('pcc_timeZone' in patientRoundingSheet.facility || 'timeZone' in patientRoundingSheet.facility)) {
      patientRoundingSheet.facility.timeZone = 'America/New_York';
    }
    let timezone = patientRoundingSheet.facility.pcc_timeZone ? patientRoundingSheet.facility.pcc_timeZone : patientRoundingSheet.facility.timeZone;
    let serviceDate = moment(patientRoundingSheet.date).utc().tz(timezone).format('MM/DD/YYYY')
    return serviceDate;
  }
  checkVoidCensus(patientRoundingSheet) {
    if (patientRoundingSheet) {
      if (patientRoundingSheet?.is_void) {
        if (patientRoundingSheet.is_void === true) return false;
        else return true;
      } else {
        return true
      }
    } else {
      return true;
    }
  }
  getCensusListByStatus(status) {
    this.censusStatus = status;
    this.initPatientRoundingSheets(this.filter_facility_id, this.filter_provider_id, this.showLimit);
  }
  cutCensusShort() {
    this.dataSource.data = this.patientRoundingSheets.slice(0, 4);
    this.censusListFetchedOnce = true;
  }
  async downloadAll(censusId) {
    const response: any = await this.censusPatientListServie.getRecentNoteByCensusId(censusId).toPromise();
    var notes = [];
    if (response.status === 200) {
      for (let note of response.data) {
        if (note.is_signed === "true") {
          let obj = {
            note_id: note._id,
            title: note.transcribtion_title
          }
          notes.push(obj)
        }
      }
      if (notes.length !== 0) {
        const infoToast = this.toastr.info('Downloading Notes...', 'Please wait');
        this.noteEditorService.downloadBatchNotes(notes).subscribe((res: any) => {
          if (res instanceof HttpResponse) {
            var url = window.URL.createObjectURL(res.body);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = "All Notes";
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
            this.toastr.success('Census notes has been downloaded successfully', "Success")
          }
        })
      } else if (notes.length === 0) {
        this.toastr.error('There Are No Signed Notes In Census', 'Failed')
      }
    }
  }
  async exportNote(roundingSheet) {
    var notesIds = [];
    const response: any = await this.censusPatientListServie.getRecentNoteByCensusId(roundingSheet._id).toPromise();
    if (response.status == 200) {
      for (let note of response.data) {
        if (note.is_signed === "true") {
          notesIds.push(note._id)
        }
      }
    }
    if (notesIds.length !== 0) {
      const dialogRef = this.dialog.open(ExportNotesDialogComponent, { width: '40%', data: { facility_id: roundingSheet.facility?._id } });
      dialogRef.afterClosed().subscribe(async result => {
        if (result.emails?.length > 0) {
          this.toastr.info('Sending emails', 'Sending...');
          let provider_name = roundingSheet.createdBy;
          let facility_name = roundingSheet.facility.title;
          // @ts-ignore 
          this.noteEditorService.generatePDFsLinksAndEmail(result.emails, notesIds, provider_name, facility_name, true)
            .subscribe((response: any) => {
              if (response.status == 200) {
                this.toastr.info('Emails sent');
              }
            }, () => {
            }, () => {
            })
        }
      })
    } else if (notesIds.length === 0) {
      this.toastr.error('There Are No Signed Notes In Census', 'Failed')
    }
  }
  getActivePatientsCount(census) {
    if (census?.patientList) {
      if ((census?.patientList?.length - census?.patientsInactive?.length) > 0) {
        return (census?.patientList?.length - census?.patientsInactive?.length)
      } else {
        return 0
      }
    }
  }
  watchHelpVideo(videoId) {
    const dialogRef = this.dialog.open(WatchHelpVideoDialog, {
      data: { videoId }
    });
    dialogRef.afterClosed().subscribe(console.log);
  }
}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b);
  }
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}